export default [
	'node.js',
	'react native',
	'.net',
	'flask',
	'django',
	'php',
	'laravel',
	'ruby',
	'rails',
	'sql',
	'css',
	'react',
	'angular',
	'vue',
	'jquery',
	'ajax',
	'flutter',
	'kotlin',
	'swift',
	'docker',
	'javascript',
	'python',
	'wordpress',
	'objectivec',
	'bash',
	'testing',
	'android',
	'rest',
	'ios',
	'devops',
	'c#',
	'kubernetes',
	'html',
	'agile',
	'aws',
	'wireframing',
	'automation',
	'express',
	'scala',
	'linux',
	'typescript',
	'spring',
	'redux',
	'selenium',
	'oop',
	'websocket',
	'postman',
	'spark',
	'magneto',
	'scrum',
	'azure',
	'codeigniter',
	'nest.js',
	'mongo',
	'graphql',
	'kafka',
	'sass',
	'rdbms',
	'soab',
	'hibernate',
	'git',
	'jenkins',
	'mvvm',
	'katalon',
	'api',
	'c',
	'warehous',
	'responsive',
	'swagger',
	'postgraphile',
	'ansible',
	'photoshop',
	'jira',
	'data structures',
	'machine learning',
	'algorithms',
	'oracle',
	'design patterns',
	'data analysis',
	'matlab',
	'xml',
	'bootstrap',
	'data science',
	'firebase',
	'xamarin',
	'odoo',
	'mean',
	'mern',
	'deep learning',
	'entity framework',
	'json',
	'linq',
	'mvc',
	'tfs',
	'wcf',
	'servlet',
	'prisma',
	'figma',
	'adobe xd',
	'less',
	'istqb',
	'numpy',
	'database',
	'pytorch',
	'golang',
	'postgres',
	'java',
	'pearl',
	'assembly',
	'dagger',
	'scikit',
	'keras',
	'tensorflow',
	'elasticsearch',
	'excel'
];

function stringAlike(str1, str2) {
	if (!Array.isArray(str1)) str1 = str1.split('');
	if (!Array.isArray(str2)) str2 = str2.split('');
	let str2CharsObj = str2.reduce((prev, curr, indx) => {
		prev[curr] = (prev[curr] && prev[curr].push(indx)) || [indx];
		return prev;
	}, {});

	let match = false,
		priority = 0,
		found = {};
	for (let char of str1) {
		if (!str2CharsObj[char]) return [false, 0];
		found[char] = str2CharsObj[char];
	}
	match = true;
}

/**
 * abc
 * ------
 * abcdef                         1    0    #same order and contigous
 * efabcdef                       1    0    #same order but not contigous
 * eafbecd                        1    1    #same order but not contigous
 * ebcae                          1    2    #not same order but contigous
 * #ebeaece                       1    3    #not same order and not contigous
 * eaf                            0    x    #no match
 * eabcccccc
 * magedabcmaged
 */
